import moment from 'moment'

export default function setLocale(userLocale) {
	if (!userLocale || userLocale === 'en_US') {
		moment.locale('en')
		return
	}
	const availableLocales = moment.locales()
	const momentLocale = userLocale.replace('_', '-').toLowerCase()
	if (availableLocales.includes(momentLocale)) {
		moment.locale(momentLocale)
		return
	}
	const languageOnlyLocale = momentLocale.split('-')[0]
	if (availableLocales.includes(languageOnlyLocale)) {
		moment.locale(languageOnlyLocale)
		return
	}
	moment.locale('en')
}
